import { css, SerializedStyles } from '@emotion/core'

import { BorderRadius } from '../../../enums/borderRadius'
import { Color } from '../../../enums/color'
import { StyledComponent } from '../../../types/styledComponent'

export const getPressedStyle = (
  Control: StyledComponent,
  ControlWrapper: StyledComponent,
  checked: boolean,
): SerializedStyles => css`
  &:active {
    ${Control} {
      ${checked
        ? css`
            color: ${Color.White};
            background-color: ${Color.Lavender600};
          `
        : css`
            border-color: ${Color.Grey500};
            background-color: ${Color.White};
          `};
    }

    ${ControlWrapper} {
      border-radius: ${BorderRadius.RFull};
      box-shadow: none;
    }
  }
`
